import React, { useEffect, useState, useRef } from "react";
import './Analytics.css'
import Select from 'react-select'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import AnalyticsDownArrow from './../../../../images/analyticsdownarrow.png'
import FilterIcon from './../../../../images/filtericon.png'
import LineGraphIcon from './../../../../images/linegraphicon.png'
import LineGraphIconGrey from './../../../../images/linegraphicongrey.png'
import BarGraphIcon from './../../../../images/bargraphicon.png'
import BarGraphIconWhite from './../../../../images/bargraphiconwhite.png'
import DropDownIcon from './../../../../images/dropdownicon.png'
import UpStockArrow from './../../../../images/upstockarrow.png'
import DownStockArrow from './../../../../images/downstockarrow.png'
import NoAnalytics from './../../../../images/noanalytics.png'
import PaymentInfoBtn from './../../../../images/paymentinfobtn.png'
import calendericon from './../../../../images/calendericon.png'
import httpConfig from "../AxiosConfig/httpConfig";
import { axiosInstance } from "../AxiosConfig/AxiosInstance";
import Cookies from "universal-cookie";
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components"
import EmptyAnalytics from "./EmptyAnalytics";
import { useJwt, decodeToken } from "react-jwt";
import LoadingAnalytics from "./LoadingAnalytics";
import { logtoWix } from "../../../Helpers/LogToWix";

// import 'react-datepicker/dist/react-datepicker.css'

import {
    makeWidthFlexible, XYPlot, XAxis, YAxis, HorizontalGridLines, VerticalGridLines, LineMarkSeries, Hint, Crosshair, VerticalBarSeries
} from 'react-vis';
import 'react-vis/dist/style.css';


const StyledDatePickerWrapper = styled.div`
  .react-datepicker__input-container input {
    background-color: rgba(0,0,0,50%);
    color: #ffffff;
    border: 1px solid #rgba(255,255,255,20%);
    border-radius: 4px;
    padding-left:0.75em;
    font-size: 1rem;
    width: 16.875em;
    margin-left:1em;
    margin-bottom:1em;
    height:2em;
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker {
    background-color: #1D232A;
    border: 1px solid rgba(255,255,255,20%);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    margin-left:1.2em;
   
    border-radius:4px;

  }

  .react-datepicker__header {
    background-color: #1D232A;
    font-family:'ClashGrotesk-Variable',sans-serif;
    font-size:0.75rem;
    font-weight:400;
    line-height: 150%;
    letter-spacing: 2.5%;
    border-bottom:none;
  }


  .react-datepicker__day-name, 
  .react-datepicker__day, 
  .react-datepicker__time-name {
    color: #ffffff;
    font-family:'ClashGrotesk-Variable',sans-serif;
    font-size:0.875rem;
    font-weight:400;
    line-height: 150%;
    letter-spacing: 2.5%;
    padding:0.67em;
    border-radius:100px;
  }

  .react-datepicker__current-month {
    font-family:'ClashGrotesk-Variable',sans-serif;
    font-size:1rem;
    font-weight:500;
    line-height: 150%;
    letter-spacing: 2.5%;
    color:rgba(255,255,255,70%);
    margin-bottom:1.2em;
    margin-top:1.2em;
  }
.react-datepicker__day--in-range,
.react-datepicker__day--highlighted,
  .react-datepicker__day--selected, 
  .react-datepicker__day--keyboard-selected {
    background-color: #E91353;
    color: #ffffff;
    border-radius:100px;
  }

  .react-datepicker__day--outside-month {
    color: #666666;
  }

  .react-datepicker__triangle {
    display: none;
  }


  .react-datepicker__navigation--previous{
    height: 18.67px;
    width: 7.67px;
    margin-top:2.2em;
    margin-left:1.5em;
  }

  .react-datepicker__navigation--next{
    height: 18.67px;
    width: 7.67px;
    margin-top:2.2em;
    margin-right:1.5em;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #ffffff;
  }
`;

function Analytics({ nav, hidedashboard }) {
    const FlexibleXYPlot = makeWidthFlexible(XYPlot)
    const [viewoption, setViewOption] = useState({ value: 'Stream', label: 'Stream' })
    const [byoption, setByOption] = useState({ value: 'DSP', label: 'DSP' })
    const [statsArray, setStatsArray] = useState([]);
    const [statDatesArray, setDatesArray] = useState([]);
    const [value, setValue] = useState();
    const [loading, setLoading] = useState(true);
    const [legend, setLegend] = useState([]);
    const datetoday = new Date();
    const [loadingGraphState, setloadingGraphState] = useState(true);
    const [emptyGraphState, setEmptyGraphState] = useState(false);

    const [dateFilter, setDateFilter] = useState("Last 7 days")

    const [emptyAnalytics, setEmptyAnalytics] = useState(true)

    const [currentStatTotal, setCurrentStatTotal] = useState(0)
    const [lastStatTotal, setLastStatTotal] = useState(0)

    const [ygraphpoints, setYGraphPoints] = useState([])
    const [myValue, setMyValue] = useState([])
    const [graphOption, setGraphOption] = useState(0)
    const [filterOption, setFilterOption] = useState(0)
    const [hintValue, setHintValue] = useState(undefined);
    const [hint, setHint] = useState(undefined);
    const navigate = useNavigate();


    const [refreshGraph, setRefreshGraph] = useState(0);

    const [xgraphpoints, setXGraphPoints] = useState([[]]);
    const [thisweekTotals, setThisWeekTotals] = useState(new Array())
    const [lastweekTotals, setLastWeekTotals] = useState(new Array())

    const [percentChanges, setPercentChanges] = useState([])
    const [statsListMap, setStatsListMap] = useState(new Map())
    const [statsListArray, setStatsListArray] = useState([])
    const [statslist, setStatsList] = useState([])
    const [checkarray, setCheckArray] = useState(0)

    const [asset, setAsset] = useState("")
    const [assetId, setAssetId] = useState("")
    const [product, setProduct] = useState("")
    const [productId, setProductId] = useState("")
    const [dsp, setdsp] = useState("")
    const [dspid, setdspid] = useState("")
    const [territory, setTerritory] = useState("")
    const [territoryId, setTerritoryId] = useState("")
    const [daterange, setDateRange] = useState(-1)

    const [customstartdate, setCustomStartDate] = useState("")
    const [customenddate, setCustomEndDate] = useState("")

    const [assetOptions, setAssetOptions] = useState([])
    const [AssetSearch, setAssetSearch] = useState([])
    const [enableAssetSearch, setEnableAssetSearch] = useState(false)
    const [productOptions, setProductOptions] = useState([])
    const [ProductSearch, setProductSearch] = useState([])
    const [enableProductSearch, setEnableProductSearch] = useState(false)

    const [territorySearch, setTerritorySearch] = useState([])
    const [enableTerritorySave, setEnableTerritorySave] = useState(false)
    const [DSPSearch, setDSPSearch] = useState([])
    const [enableDSPSave, setEnableDSPSave] = useState(false)

    const isHoveringOverLine = useRef({});
    const [hoveredPoint, setHoveredPoint] = useState([]);

    const [colors, setColors] = useState(["#ff7f0e", "#ffbb78", "#1f77b4", "#2ca02c", "#aec7e8", "#2ca02c"])

    const { t, i18n } = useTranslation();
    const cookies = new Cookies(null, { path: '/' });

    const hasLogged = useRef(false);


    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })

        }

        window.addEventListener('resize', handleResize)

        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    const _forgetValue = () => {
        setHintValue(false);
        console.log("Exited dot")
        setLegend([])
    };

    const _rememberValue = (value) => {
        console.log(value)
        setHintValue(value);
        getLegend(value.x);
    };

    const _onNearestX = (value) => {
        setHintValue(value)
    }

    // Function to add class to future dates
    const getDayClassName = (date) => {
        const today = new Date();
        if (date > today) {
            return "react-datepicker__day--future";  // Add custom class to future dates
        }
        return "";
    };

    const viewOptions = [{ value: 'Stream', label: 'Stream' },
    { value: 'Download', label: 'Download' },
    { value: 'Spotify Insights', label: 'Spotify Insights' },
    { value: 'Apple Music Insights', label: 'Apple Music Insights' },
    { value: 'Deezer Insights', label: 'Deezer Insights' },
    { value: 'Amazon Insights', label: 'Amazon Insights' },
    { value: 'Pandora Insights', label: 'Pandora Insights' },
    { value: 'Line Music Insights', label: 'Line Music Insights' },
    { value: 'Tiktok Insights', label: 'Tiktok Insights' },
    { value: 'Playlists', label: 'Playlists' },
    { value: 'Custom reports', label: 'Custom reports' }]

    const jpviewOptions = [{ value: 'Stream', label: 'ストリーム数' },
    { value: 'Download', label: 'ダウンロード数' },
    { value: 'Spotify Insights', label: 'Spotify インサイト' },
    { value: 'Apple Music Insights', label: 'Apple Music インサイト' },
    { value: 'Deezer Insights', label: 'Deezer インサイト' },
    { value: 'Amazon Insights', label: 'Amazon インサイト' },
    { value: 'Pandora Insights', label: 'Pandora インサイト' },
    { value: 'Line Music Insights', label: 'Line Music  インサイト' },
    { value: 'Tiktok Insights', label: 'TikTiok  インサイト' },
    { value: 'Playlists', label: 'プレイリスト' },
    { value: 'Custom reports', label: 'カスタムレポート' }]

    const byOptions = [{ value: 'DSP', label: 'DSP' },
    { value: 'Territory', label: 'Territory' },
    { value: 'Asset', label: 'Asset' },
    ]

    const jpbyOptions = [{ value: 'DSP', label: 'DSP別' },
    { value: 'Territory', label: '地域別' },
    { value: 'Asset', label: 'レーベル別' },
    ]

    const DSPOptions = [
        { value: 'Amazon Music', label: 'Amazon Music' },
        { value: 'Spotify', label: 'Spotify' },
        { value: 'Apple Music', label: 'Apple Music' },
        { value: 'Deezer', label: 'Deezer' },
        { value: 'Pandora', label: 'Pandora' },
        { value: 'SoundCloud', label: 'SoundCloud' },
        { value: 'YouTube', label: 'YouTube' },
        { value: 'Spotify_30', label: 'Spotify_30' },
        { value: 'Apple Music_30', label: 'Apple Music_30' }
    ]

    const changeViewHandler = value => {
        setViewOption(value)
        setRefreshGraph(Math.random())
    }

    const changeByHandler = value => {
        setByOption(value)
        setRefreshGraph(Math.random())
    }


    const colourStyles = {
        control: styles => ({
            ...styles, borderColor: '#636468',
            backgroundColor: '#182833',
            width: '10em',
            height: '2.5em',
            borderRadius: '8px',
            color: 'rgba(255, 255, 255, 1)',
            marginLeft: '0.5em'
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#18191F',
                color: 'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop: '-0.3em',
                marginBottom: '-0.3em',
                borderRadius: '3px'
            };
        },
        input: (styles) => ({
            ...styles,
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%',
            color: 'rgba(255, 255, 255, 1)'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%'
        }),
        menuList: (base) => ({
            ...base,
            "::-webkit-scrollbar": {
                width: "0px",
                height: "0px",
            },
            "::-webkit-scrollbar-track": {
                background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
                background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: "#555"
            }
        })
    };

    const FiltercolourStyles = {
        control: styles => ({
            ...styles, borderColor: '#636468',
            backgroundColor: '#18191F',
            width: '15em',
            height: '2.5em',
            borderRadius: '8px',
            color: 'rgba(255, 255, 255, 1)',
            marginLeft: '0.5em'
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#18191F',
                color: 'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop: '-0.3em',
                marginBottom: '-0.3em'
            };
        },
        input: (styles) => ({
            ...styles,
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%',
            color: 'rgba(255, 255, 255, 1)'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%'
        })
    };


    {/** Use Effect Functions */ }
    useEffect(() => {
        if (cookies.get("artistname").length !== 0) {
            // fetchGraphData()
            updatedfetchGraphData()
            setEmptyAnalytics(false)
        }
        hidedashboard(true)
        nav("Analytics")

        if (decodeToken(cookies.get('token')).info !== undefined) {
            if (decodeToken(cookies.get('token')).info.artistName !== undefined) {
                getArtistId(decodeToken(cookies.get('token')).info.artistName).then((res) => {
                    getAssetsandProducts(res.data.artist[0].id)
                })
            }
        }

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard Analytics Page", { "desc": "User opened the artist dashboard analytics page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "Artist Dashboard Analytics Page", { "desc": "User opened the artist dashboard analytics page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "Artist Dashboard Analytics Page", { "desc": "User opened the artist dashboard analytics page" })
                hasLogged.current = true;
            }
        }
    }, [])

    {/*get Artist Id*/ }
    const getArtistId = async (name) => {
        return await axios.get("https://n3rve.fly.dev/artists?name=".concat(name))
    }

    useEffect(() => {
        if (cookies.get("artistname").length !== 0) {
            // fetchGraphData()
            //    updatedfetchGraphData()
        }

    }, [viewoption, byoption])


    useEffect(() => {

    }, [statsListArray])


    useEffect(() => {

    }, [daterange])

    useEffect(() => {
        if (refreshGraph !== 0) {
            updatedfetchGraphData()
        }
    }, [refreshGraph])


    useEffect(() => {
        console.log("This is main graph data")
        console.log(xgraphpoints)
        console.log(xgraphpoints.xycoord)
        if (xgraphpoints.xycoord === undefined) {
            setloadingGraphState(true)
        } else {
            setloadingGraphState(false)
        }
    }, [xgraphpoints])


    useEffect(() => {

    }, [statsListArray, statsArray])

    useEffect(() => {


        if (thisweekTotals !== undefined && lastweekTotals !== undefined) {
            if (thisweekTotals.length !== 0 && lastweekTotals.length !== 0) {
                console.log("There has been an update")
                updatedStats()
            }
        }

    }, [lastweekTotals, thisweekTotals])

    useEffect(() => {
        console.log(currentStatTotal)
        console.log(lastStatTotal)

    }, [currentStatTotal, lastStatTotal])



    const updatedfetchGraphData = async () => {
        setXGraphPoints([[]])
        setThisWeekTotals([])
        setLastWeekTotals([])
        setStatsListMap(new Map())

        // const todaydate = new Date()
        // const enddate = new Date(todaydate - 2* 24 * 60 * 60 * 1000)
        // const startdate = new Date(enddate - 6 * 24 * 60 * 60 * 1000)
        // const lastweekstartdate = new Date(enddate - 13 * 24 * 60 * 60 * 1000)
        // const lastweekenddate = new Date(enddate - 7 * 24 * 60 * 60 * 1000)
        // const todaydate = new Date()
        var enddate
        var startdate
        var lastweekstartdate
        var lastweekenddate

        [enddate, startdate, lastweekstartdate, lastweekenddate] = calculateStartAndEndDate()

        const startdatestr = ''.concat(startdate.getMonth() + 1).concat('-').concat(startdate.getDate()).concat('-').concat(startdate.getFullYear())
        const enddatestr = ''.concat(enddate.getMonth() + 1).concat('-').concat(enddate.getDate()).concat('-').concat(enddate.getFullYear())
        const lastweekstartdatestr = ''.concat(lastweekstartdate.getMonth() + 1).concat('-').concat(lastweekstartdate.getDate()).concat('-').concat(lastweekstartdate.getFullYear())
        const lastweekenddatestr = ''.concat(lastweekenddate.getMonth() + 1).concat('-').concat(lastweekenddate.getDate()).concat('-').concat(lastweekenddate.getFullYear())

        var xpoints = [];
        var currentweekdata = [];
        // var lastweekdata = [];

        var thisWeekStats
        var lastWeekStats
        var thisWeekStatsUrl = ""
        var lastWeekStatslUrl = ""

        thisWeekStatsUrl = thisWeekStatsUrl.concat("https://n3rve.fly.dev/analytics?start_date=").concat(startdatestr).concat('&end_date=').concat(enddatestr).concat("&selection_type=").concat(byoption.value.toLowerCase()).concat("&sale_type=").concat(viewoption.value.toLowerCase());
        lastWeekStatslUrl = lastWeekStatslUrl.concat("https://n3rve.fly.dev/analytics?start_date=").concat(lastweekstartdatestr).concat('&end_date=').concat(lastweekenddatestr).concat("&selection_type=").concat(byoption.value.toLowerCase()).concat("&sale_type=").concat(viewoption.value.toLowerCase());

        if (asset.length !== 0) {
            thisWeekStatsUrl = thisWeekStatsUrl.concat("&asset_id=").concat(assetId);
            lastWeekStatslUrl = lastWeekStatslUrl.concat("&asset_id=").concat(assetId);
        }

        if (product.length !== 0) {
            thisWeekStatsUrl = thisWeekStatsUrl.concat("&product_id=").concat(productId);
            lastWeekStatslUrl = lastWeekStatslUrl.concat("&product_id=").concat(productId);
        }

        if (dspid.length !== 0) {
            thisWeekStatsUrl = thisWeekStatsUrl.concat("&dsp_id=").concat(dspid);
            lastWeekStatslUrl = lastWeekStatslUrl.concat("&dsp_id=").concat(dspid);
        }

        if (territoryId.length !== 0) {
            thisWeekStatsUrl = thisWeekStatsUrl.concat("&territory_id=").concat(territoryId);
            lastWeekStatslUrl = lastWeekStatslUrl.concat("&territory_id=").concat(territoryId);
        }

        thisWeekStats = axios.get(thisWeekStatsUrl, { headers: { Authorization: "Bearer ".concat(cookies.get("token")) } });
        lastWeekStats = axios.get(lastWeekStatslUrl, { headers: { Authorization: "Bearer ".concat(cookies.get("token")) } });

        logtoWix(decodeToken(cookies.get('token')).email, "Fuga Analytics", "Artist Dashboard Analytics Page", { "desc": "User called Fuga Analytics", "startdate": startdate, "enddate": enddate, "selection_type": byoption.value.toLowerCase(), "sale_type": viewoption.value.toLowerCase(), "asset_id": assetId, "product_id": productId, "dsp_id": dspid, "territory_id": territoryId })

        Promise.all([thisWeekStats, lastWeekStats])
            .then(([thisWeekResponse, lastWeekResponse]) => {
                // Do something when both requests are complete
                console.log("Response from Request One: ", thisWeekResponse.data.data.length);
                console.log("Response from Request Two: ", lastWeekResponse.data.data.length);


                if (thisWeekResponse.data.data.length === 0) {
                    setEmptyGraphState(true)
                } else {
                    setEmptyGraphState(false)


                    // To Generate the graph Response 1 operations
                    // Main Array to store Stats Eg spotify:[102332,34534,45454]
                    setStatsArray(thisWeekResponse.data.data)

                    // To Generate the dates of the Graph
                    // Main Array to store dates for X Axis of graph
                    generateDateArray(thisWeekResponse.data.data, startdatestr)

                    PopulateGraph(thisWeekResponse.data.data)

                    CalculateCurrentWeekTotals(thisWeekResponse.data.data)

                    CalculateLastWeekTotals(lastWeekResponse.data.data)
                }



            })
            .catch(error => {
                console.error("Error in one of the requests: ", error);
            });

    }

    const calculateStartAndEndDate = () => {
        var todaydate = new Date()
        var enddate
        var startdate
        var lastTPstartdate
        var lastTPenddate

        if (dateFilter === "This Week") {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(enddate)
            startdate.setDate(enddate.getDate() - enddate.getDay());
            lastTPstartdate = new Date(enddate - 13 * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(enddate - 7 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "Last Week") {
            enddate = new Date(todaydate)
            enddate.setDate(todaydate.getDate() - todaydate.getDay() - 1);
            startdate = new Date(enddate - 6 * 24 * 60 * 60 * 1000)
            lastTPstartdate = new Date(enddate - 13 * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(enddate - 7 * 24 * 60 * 60 * 1000)
        }


        if (dateFilter === "Last 7 days") {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(enddate - 6 * 24 * 60 * 60 * 1000)
            lastTPstartdate = new Date(enddate - 13 * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(enddate - 7 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "Last 14 days") {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(enddate - 13 * 24 * 60 * 60 * 1000)
            lastTPstartdate = new Date(enddate - 27 * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(enddate - 14 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "Last 30 days") {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(enddate - 29 * 24 * 60 * 60 * 1000)
            lastTPstartdate = new Date(enddate - 59 * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(enddate - 30 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(getMonthTxtFull(datetoday.getMonth()))) {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(todaydate.getFullYear(), todaydate.getMonth(), 1)
            var daybetween = getDaysBetweenDates(startdate, enddate)
            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(getMonthTxtFull(datetoday.getMonth() - 1))) {
            enddate = new Date(todaydate.getFullYear(), todaydate.getMonth(), 0)
            startdate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 1, 1)

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(getMonthTxtFull(datetoday.getMonth() - 2))) {
            enddate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 1, 0)
            startdate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 2, 1)

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }


        if (dateFilter === "".concat(getMonthTxtFull(datetoday.getMonth() - 3))) {
            enddate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 2, 0)
            startdate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 3, 1)

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(getMonthTxtFull(datetoday.getMonth() - 4))) {
            enddate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 3, 0)
            startdate = new Date(todaydate.getFullYear(), todaydate.getMonth() - 4, 1)

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)


        }

        if (dateFilter === "".concat(datetoday.getFullYear())) {
            enddate = new Date(todaydate - 2 * 24 * 60 * 60 * 1000)
            startdate = new Date(todaydate.getFullYear() - 1, 0, 1);

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(datetoday.getFullYear() - 1)) {
            enddate = new Date(todaydate.getFullYear() - 1, 11, 31)
            startdate = new Date(todaydate.getFullYear() - 1, 0, 1);

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(datetoday.getFullYear() - 2)) {
            enddate = new Date(todaydate.getFullYear() - 2, 11, 31)
            startdate = new Date(todaydate.getFullYear() - 2, 0, 1);

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }

        if (dateFilter === "".concat(datetoday.getFullYear() - 3)) {
            enddate = new Date(todaydate.getFullYear() - 3, 11, 31)
            startdate = new Date(todaydate.getFullYear() - 3, 0, 1);

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }



        if (customstartdate.length !== 0 && customenddate.length !== 0) {
            enddate = new Date(customenddate)
            startdate = new Date(customstartdate);

            var daybetween = getDaysBetweenDates(startdate, enddate)

            lastTPstartdate = new Date(startdate - daybetween * 24 * 60 * 60 * 1000)
            lastTPenddate = new Date(startdate - 1 * 24 * 60 * 60 * 1000)
        }




        return ([enddate, startdate, lastTPstartdate, lastTPenddate])
    }

    function getDaysBetweenDates(date1, date2) {
        // Get the time difference in milliseconds
        var timeDifference = Math.abs(date2.getTime() - date1.getTime());

        // Convert the time difference from milliseconds to days
        var dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24)); // 1000 ms * 3600 sec * 24 hours

        return dayDifference;
    }

    const getAssetsandProducts = (labelid) => {
        // PENDING REPLACE INT WITH LABEL ID
        axios.get("https://n3rve.fly.dev/analytics/options?artist=".concat(6667124377),
            { headers: { Authorization: "Bearer ".concat(cookies.get("token")) } })
            .then((response) => { console.log(response.data); setAssetOptions(response.data.assets); setProductOptions(response.data.products) })
            .catch((err) => console.log(err))
    }



    const PopulateGraph = (data) => {
        setXGraphPoints([[]])
        var xpoints = [];

        data.map((datapoint, index) => {
            const xycoords = [];
            var totals = [];
            var sum = 0;

            (datapoint.totals.map((point, index) => {
                // if(point>maxvalue){
                //     maxvalue=point 
                // }

                xycoords.push({ x: statDatesArray[index], y: point })
            }))

            totals.push(sum)
            xpoints[index] = xycoords

            // Used to go Perc Calculations
            // statsListMap.set(datapoint.name,[sum])
        })


        // Main Array to store graph data Eg desc: [{name:"Spotify",totals:[12012,2323,3434]}],xycoord:[{x:'19 Sep',y:12123}]}
        setXGraphPoints((prevState) => {
            return {
                xycoord: xpoints,
                desc: data
            }
        })
    }

    const CalculateCurrentWeekTotals = (data) => {
        var currentweekdata = [];
        setThisWeekTotals([])
        setCurrentStatTotal(0)
        setStatsListArray([])
        var statlist = []

        data.map((datapoint, index) => {
            // Total streams last week Eg Spotify 120000
            var sum = 0;


            (datapoint.totals.map((point, index) => {
                sum = sum + point
            }))

            currentweekdata.push(sum)

            if (datapoint.name !== 'Spotify_30' && datapoint.name !== 'Apple Music_30') {
                setCurrentStatTotal((prevState) => {
                    return (
                        prevState + sum
                    )
                })
            }
            statlist.push({ title: datapoint.name, streams: sum })
            // statsListMap.set(datapoint.name,[sum])
        })

        setThisWeekTotals(currentweekdata)
        setStatsListArray(statlist)
    }

    const CalculateLastWeekTotals = (data) => {
        setLastWeekTotals([])
        var lastweekdata = [];
        // To Generate the stats Response 2 operations
        setLastStatTotal(0)
        data.map((datapoint, index) => {
            // Total streams last week Eg Spotify 120000
            var sum = 0;
            (datapoint.totals.map((point, index) => {
                sum = sum + point
            }))
            lastweekdata.push(sum)
            if (datapoint.name !== 'Spotify_30' && datapoint.name !== 'Apple Music_30') {
                setLastStatTotal((prevState) => {
                    return (
                        prevState + sum
                    )
                })
            }
        })
        setLastWeekTotals(lastweekdata)
    }

    const generateDateArray = (stats, date) => {
        var curdate = new Date(date)
        setDatesArray([])
        stats[0].totals.map(stat => {
            statDatesArray.push("".concat(curdate.getDate()).concat(" ").concat(getMonthTxt(curdate.getMonth())))
            curdate = new Date(curdate.getTime() + 24 * 60 * 60 * 1000)
        })
    }






    const getStats = () => {
        var percchange = []
        var graphstats = []

        // setStatsListArray([])
        for (let i = 0; i < lastweekTotals.length; i++) {
            percchange[i] = Math.round(((thisweekTotals[i] - lastweekTotals[i]) / lastweekTotals[i]) * 10000) / 100
            statsListMap.get(Array.from(statsListMap.keys())[i]).push(percchange[i])
            graphstats[i] = { name: Array.from(statsListMap.keys())[i], total: statsListMap.get(Array.from(statsListMap.keys())[i])[0], change: statsListMap.get(Array.from(statsListMap.keys())[i])[1] }
        }
        console.log("Updated Statlist Dropped")
        console.log(graphstats)
        setStatsListArray((prevState) => {
            return {
                statslist: graphstats
            }
        })

    }

    const updatedStats = () => {
        var percchange = []

        const statlistwoperc = [...statsListArray]
        var graphstats = []
        console.log("In Stat list")
        console.log(thisweekTotals)
        console.log(lastweekTotals)

        statlistwoperc.map((stat, index) => {
            graphstats.push({ title: stat.title, streams: stat.streams, streamchange: Math.round(((thisweekTotals[index] - lastweekTotals[index]) / lastweekTotals[index]) * 10000) / 100 })
        })


        // setStatsListArray([])
        // for(let i=0;i<lastweekTotals.length;i++){
        //     percchange[i] =  Math.round(((thisweekTotals[i] - lastweekTotals[i])/ lastweekTotals[i])*10000)/100
        //     statsListMap.get(Array.from(statsListMap.keys())[i]).push(percchange[i])
        //     graphstats[i]={name:Array.from(statsListMap.keys())[i],total:statsListMap.get(Array.from(statsListMap.keys())[i])[0],change:statsListMap.get(Array.from(statsListMap.keys())[i])[1]}
        // }
        console.log("Updated Statlist Dropped")
        console.log(graphstats)
        // setStatsListArray((prevState)=>{
        //     return {  
        //         statslist:graphstats
        //     }
        // }) 
        setStatsListArray(graphstats)
    }

    const getDSPOptions = (data) => {
        axios.get("https://n3rve.fly.dev/analytics/options/dsp?text=".concat(data),
            { headers: { Authorization: "Bearer ".concat(cookies.get("token")) } })
            .then((response) => { console.log(response.data); setDSPSearch(response.data) })
            .catch((err) => console.log(err))
    }



    const getProductOptions = (value) => {
        const match = []
        productOptions.map((searchmatch) => {
            if (value.length !== 0) {
                if (searchmatch.name.toLowerCase().includes(value.toLowerCase())) {
                    match.push(searchmatch)
                }
            }
        })
        setProductSearch(match)
    }


    const getAssetOptions = (value) => {
        const match = []
        assetOptions.map((searchmatch) => {
            if (value.length !== 0) {
                if (searchmatch.name.toLowerCase().includes(value.toLowerCase())) {
                    match.push(searchmatch)
                }
            }
        })
        setAssetSearch(match)
    }

    const getTerritoryOptions = (data) => {
        axios.get("https://n3rve.fly.dev/analytics/options/territory?text=".concat(data),
            { headers: { Authorization: "Bearer ".concat(cookies.get("token")) } })
            .then((response) => setTerritorySearch(response.data))
            .catch((err) => console.log(err))
    }


    const getLegend = (day) => {
        var xpoints = []
        xgraphpoints.xycoord !== undefined && xgraphpoints.xycoord.map((graphpoint, index) => {
            graphpoint.map((pt => {
                if (pt.x === day) {
                    xpoints.push({ name: xgraphpoints.desc[index].name, value: pt.y })
                }
            }))
        })
        setLegend(xpoints)
    }

    const arrlen = (arr) => {
        var count = 0;
        console.log(arr)

        for (var i of arr.values()) {
            count = count + 1
            console.log(i)
        }
        return count;
    }
    useEffect(() => {
        console.log(filterOption)
    }, [filterOption])



    const getMonthTxt = (i) => {
        switch (i) {
            case 0: return 'Jan'
                break
            case 1: return 'Feb'
                break
            case 2: return 'Mar'
                break
            case 3: return 'Apr'
                break
            case 4: return 'May'
                break
            case 5: return 'Jun'
                break
            case 6: return 'Jul'
                break
            case 7: return 'Aug'
                break
            case 8: return 'Sep'
                break
            case 9: return 'Oct'
                break
            case 10: return 'Nov'
                break
            case 11: return 'Dec'
                break
        }
    }

    const getMonthTxtFull = (i) => {
        switch (i) {
            case 0: return 'January'
                break
            case 1: return 'February'
                break
            case 2: return 'March'
                break
            case 3: return 'April'
                break
            case 4: return 'May'
                break
            case 5: return 'June'
                break
            case 6: return 'July'
                break
            case 7: return 'August'
                break
            case 8: return 'September'
                break
            case 9: return 'October'
                break
            case 10: return 'November'
                break
            case 11: return 'December'
                break
        }
    }

    const closefilter = () => {
        console.log("closing filter")
        setFilterOption(0)
    }

    const getYAxisCoords = (max) => {
        var factor = 1
        var div = max
        while (div > 100) {
            factor = factor * 10
            div = div / 10
        }
        const maxvalue = roundOffTo(max, factor)
        for (let i = 0; i < 5; i++) {
            ygraphpoints.push(maxvalue / 4 * i)
        }
    }

    const roundOffTo = (max, factor) => {
        const quotient = max / factor
        const res = Math.round(quotient + 1) * factor;
        return res
    }




    return (
        <div style={{ minHeight: '100vh', height: 'auto', paddingBottom: '5em' }}>
            {
                emptyAnalytics &&
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center" }}>

                    <img src={NoAnalytics} style={{ height: '12.5em', width: '22.125em', marginTop: '9.81em', marginBottom: '1.5em' }} />
                    <div className="NoAnalticsH1">No Data Yet</div>
                    <div className="NoAnalticsH2">Release your music to see insights and analytics from streaming platforms here.</div>
                    <div className="ReleaseMusicRedBtn" onClick={() => navigate("/Dashboard/releasemusic")}>Release Music</div>
                </div>
            }

            {
                emptyGraphState &&
                <div className="AnalyticsContainer">
                    <div className="AnalyticsHeader">{t('Analyticsheader')}</div>


                    <div style={{ width: '90%', marginLeft: '2.5em' }}>
                        <EmptyAnalytics />
                    </div>

                </div>
            }

            {
                !emptyAnalytics && !emptyGraphState &&
                <div className="AnalyticsContainer">
                    <div className="AnalyticsHeader">{t('Analyticsheader')}</div>


                    {
                        loadingGraphState &&
                        <div style={{ width: '90%', marginLeft: '2.5em' }}>
                            <LoadingAnalytics />
                        </div>
                    }

                    {
                        !loadingGraphState &&
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'flex-start', width: '90%', marginLeft: '2.5em' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.5em', marginLeft: '0.7em' }}>
                                    <div className="ViewHeader">{t('View')}</div>
                                    {
                                        cookies.get('lang') === 'en' &&
                                        <Select options={viewOptions} value={viewoption} onChange={changeViewHandler}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                            defaultValue={{ label: "Streams", value: "Streams" }}
                                        />
                                    }

                                    {
                                        cookies.get('lang') === 'jp' &&
                                        <Select options={jpviewOptions} value={viewoption} onChange={changeViewHandler}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                            defaultValue={{ label: "ストリーム数", value: "Streams" }}
                                        />
                                    }


                                    <div className="ViewHeader" style={{ marginLeft: '2em', marginRight: '1em' }}>{t('By')}</div>
                                    {
                                        cookies.get('lang') === 'en' &&
                                        <Select options={byOptions} value={byoption} onChange={changeByHandler}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                            defaultValue={{ label: "DSP別", value: "DSP" }}
                                        />
                                    }

                                    {
                                        cookies.get('lang') === 'jp' &&
                                        <Select options={jpbyOptions} value={byoption} onChange={changeByHandler}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            styles={
                                                colourStyles
                                            }
                                            defaultValue={{ label: "DSP別", value: "DSP" }}
                                        />
                                    }

                                </div>

                                {/* <div className="CustomReportBtn">
                {t('Createcustomreport')}
                </div> */}
                            </div>
                            <div style={{ width: '90%', height: '0.5px', backgroundColor: '#595959', marginTop: '2em', marginBottom: '2em', marginLeft: '2.5em', alignSelf: 'center' }} />
                            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '2.5em', alignItems: 'center', flexWrap: 'wrap', width: '80%', alignItems: 'center' }}>

                                    <div style={{ flex: 'dispay', flexDirection: 'column' }}>
                                        <div className="FilterBtn" style={{ cursor: 'pointer' }} onClick={() => setFilterOption(1)}>
                                            {
                                                asset.length === 0 &&
                                                <div className="FilterBtnHeading">{t('Asset')}</div>
                                            }
                                            {
                                                asset.length !== 0 &&
                                                <div className="FilterBtnHeading">{asset}</div>
                                            }

                                            <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon" />

                                        </div>
                                        {
                                            filterOption === 1 &&
                                            <div>
                                                <div className="blocker" onClick={() => { setFilterOption(0); }}>'</div>
                                                <div style={{ backgroundColor: '#2A333D', borderRadius: '4px', width: '20.875em', marginTop: '-0.5em', position: 'absolute', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                    <div className="FilterBtnHeading" style={{ paddingTop: '1em', paddingLeft: '1em', marginBottom: '1em' }}>{t('Asset')}</div>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            value={asset}
                                                            onChange={e => { setAsset(e.target.value); getAssetOptions(e.target.value); setEnableAssetSearch(false) }}
                                                            // style={{
                                                            //     borderColor: '#636468',
                                                            //     backgroundColor:'#18191F',
                                                            //     width: '17em',
                                                            //     height: '2.5em',
                                                            //     borderRadius:'8px',
                                                            //     color:'rgba(255, 255, 255, 1)',
                                                            //     marginLeft:'0.5em'
                                                            // }}
                                                            className="FilterSearch"
                                                            type='text'
                                                        />
                                                        <div style={{ position: 'absolute', top: '3em', left: '0.9em', backgroundColor: 'rgba(0,0,0,90%)', width: '19.275em', borderRadius: '4px', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                            {AssetSearch.length !== 0 &&
                                                                AssetSearch.map((product) => {
                                                                    return (
                                                                        <div className="FilterSearchItem" onClick={() => { setAsset(product.name); setAssetId(product.id); setAssetSearch([]); setEnableAssetSearch(true) }}>
                                                                            {product.name}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '95%', justifyContent: 'flex-end', alignItems: 'center', paddingTop: '1em', paddingBottom: '1em' }}>
                                                        <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setAsset(""); setAssetId("") }}>
                                                            Clear
                                                        </div>

                                                        {
                                                            asset.length === 0 &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setAsset(""); setAssetId("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            asset.length !== 0 && !enableAssetSearch &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setAsset(""); setAssetId("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            asset.length !== 0 && enableAssetSearch &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); }}>
                                                                Cancel
                                                            </div>
                                                        }



                                                        {
                                                            !enableAssetSearch &&
                                                            <div className="SaveFilterBtn" style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
                                                                Save
                                                            </div>
                                                        }
                                                        {
                                                            enableAssetSearch &&
                                                            <div className="SaveFilterBtn" onClick={() => { setFilterOption(0); setRefreshGraph(Math.random()) }}>
                                                                <div className="HoverOverlay" style={{ top: '0em' }} />
                                                                Save
                                                            </div>
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>

                                    <div style={{ flex: 'dispay', flexDirection: 'column' }}>
                                        <div className="FilterBtn" style={{ cursor: 'pointer' }} onClick={() => setFilterOption(2)}>
                                            {
                                                product.length === 0 &&
                                                <div className="FilterBtnHeading">{t('Product')}</div>
                                            }
                                            {
                                                product.length !== 0 &&
                                                <div className="FilterBtnHeading">{product}</div>
                                            }
                                            <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon" />
                                        </div>
                                        {
                                            filterOption === 2 &&
                                            <div>
                                                <div className="blocker" onClick={() => { setFilterOption(0); }}>'</div>
                                                <div style={{ backgroundColor: '#2A333D', borderRadius: '4px', width: '20.875em', marginTop: '-0.5em', position: 'absolute', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                    <div className="FilterBtnHeading" style={{ paddingTop: '1em', paddingLeft: '1em', marginBottom: '1em' }}>{t('Product')}</div>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            value={product}
                                                            onChange={e => { setProduct(e.target.value); getProductOptions(e.target.value); setEnableProductSearch(false) }}
                                                            // style={{
                                                            //     borderColor: '#636468',
                                                            //     backgroundColor:'#18191F',
                                                            //     width: '17em',
                                                            //     height: '2.5em',
                                                            //     borderRadius:'8px',
                                                            //     color:'rgba(255, 255, 255, 1)',
                                                            //     marginLeft:'0.5em'
                                                            // }}
                                                            className="FilterSearch"
                                                            placeholder="Search Products"
                                                            type='text'
                                                        />
                                                        <div style={{ position: 'absolute', top: '3em', left: '0.9em', backgroundColor: 'rgba(0,0,0,90%)', width: '19.275em', borderRadius: '4px', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                            {ProductSearch.length !== 0 &&
                                                                ProductSearch.map((product) => {
                                                                    return (
                                                                        <div className="FilterSearchItem" onClick={() => { setProduct(product.name); setProductId(product.id); setProductSearch([]); setEnableProductSearch(true) }}>
                                                                            {product.name}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '95%', justifyContent: 'flex-end', alignItems: 'center', paddingTop: '1em', paddingBottom: '1em' }}>
                                                        <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setProduct(""); setProductId("") }}>
                                                            Clear
                                                        </div>

                                                        {
                                                            product.length === 0 &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setProduct(""); setProductId("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            product.length !== 0 && !enableProductSearch &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setProduct(""); setProductId("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            product.length !== 0 && enableProductSearch &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); }}>
                                                                Cancel
                                                            </div>
                                                        }



                                                        {
                                                            !enableProductSearch &&
                                                            <div className="SaveFilterBtn" style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
                                                                Save
                                                            </div>
                                                        }
                                                        {
                                                            enableProductSearch &&
                                                            <div className="SaveFilterBtn" onClick={() => { setFilterOption(0); setRefreshGraph(Math.random()) }}>
                                                                <div className="HoverOverlay" style={{ top: '0em' }} />
                                                                Save
                                                            </div>
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div style={{ flex: 'dispay', flexDirection: 'column' }}>
                                        <div className="FilterBtn" style={{ cursor: 'pointer' }} onClick={() => setFilterOption(3)}>
                                            {
                                                dsp.length === 0 &&
                                                <div className="FilterBtnHeading">{t('Dsp')}</div>
                                            }
                                            {
                                                dsp.length !== 0 &&
                                                <div className="FilterBtnHeading">{dsp}</div>
                                            }
                                            <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon" />
                                        </div>
                                        {
                                            filterOption === 3 &&
                                            <div>
                                                <div className="blocker" onClick={() => { setFilterOption(0); }}>'</div>
                                                <div style={{ backgroundColor: '#2A333D', borderRadius: '4px', width: '20.875em', marginTop: '-0.5em', position: 'absolute', border: '1px solid rgba(255,255,255,50%)' }}>
                                                    <div className="FilterBtnHeading" style={{ paddingTop: '1em', paddingLeft: '1em', marginBottom: '1em' }}>{t('Dsp')}</div>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            value={dsp}
                                                            onChange={e => { setdsp(e.target.value); getDSPOptions(e.target.value); setEnableDSPSave(false) }}
                                                            // style={{
                                                            //     borderColor: '#636468',
                                                            //     backgroundColor:'#18191F',
                                                            //     width: '17em',
                                                            //     height: '2.5em',
                                                            //     borderRadius:'8px',
                                                            //     color:'rgba(255, 255, 255, 1)',
                                                            //     marginLeft:'0.5em'
                                                            // }}
                                                            className="FilterSearch"
                                                            placeholder="Search DSP"
                                                            type='text'
                                                        />
                                                        <div style={{ position: 'absolute', top: '3em', left: '0.9em', backgroundColor: 'rgba(0,0,0,90%)', width: '19.275em', borderRadius: '4px', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                            {DSPSearch.length !== 0 &&
                                                                DSPSearch.map((dsp) => {
                                                                    return (
                                                                        <div className="FilterSearchItem" onClick={() => { setdsp(dsp.name); setdspid(dsp.id); setDSPSearch([]); setEnableDSPSave(true) }}>
                                                                            {dsp.name}
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '95%', justifyContent: 'flex-end', alignItems: 'center', paddingTop: '1em', paddingBottom: '1em' }}>
                                                        <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setdsp(""); setdspid("") }}>
                                                            Clear
                                                        </div>

                                                        {
                                                            dsp.length === 0 &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setdsp(""); setdspid("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            dsp.length !== 0 && !enableDSPSave &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setdsp(""); setdspid("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            dsp.length !== 0 && enableDSPSave &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); }}>
                                                                Cancel
                                                            </div>
                                                        }



                                                        {
                                                            !enableDSPSave &&
                                                            <div className="SaveFilterBtn" style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
                                                                Save
                                                            </div>
                                                        }
                                                        {
                                                            enableDSPSave &&
                                                            <div className="SaveFilterBtn" onClick={() => { setFilterOption(0); setRefreshGraph(Math.random()) }}>
                                                                <div className="HoverOverlay" style={{ top: '0em' }} />
                                                                Save
                                                            </div>
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div style={{ flex: 'dispay', flexDirection: 'column' }}>
                                        <div className="FilterBtn" style={{ cursor: 'pointer' }} onClick={() => setFilterOption(4)}>
                                            {
                                                territory.length === 0 &&
                                                <div className="FilterBtnHeading">{t('Territory')}</div>
                                            }
                                            {
                                                territory.length !== 0 &&
                                                <div className="FilterBtnHeading">{territory}</div>
                                            }

                                            <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon" />
                                        </div>

                                        {
                                            filterOption === 4 &&
                                            <div>
                                                <div className="blocker" onClick={() => { setFilterOption(0); }}>'</div>
                                                <div style={{ backgroundColor: '#2A333D', borderRadius: '4px', width: '20.875em', marginTop: '-0.5em', position: 'absolute', border: '1px solid rgba(255,255,255,50%)' }}>
                                                    <div className="FilterBtnHeading" style={{ paddingTop: '1em', paddingLeft: '1em', marginBottom: '1em' }}>{t('Territory')}</div>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            value={territory}
                                                            onChange={e => { setTerritory(e.target.value); getTerritoryOptions(e.target.value); setEnableTerritorySave(false) }}
                                                            // style={{
                                                            //     borderColor: '#636468',
                                                            //     backgroundColor:'#18191F',
                                                            //     width: '17em',
                                                            //     height: '2.5em',
                                                            //     borderRadius:'8px',
                                                            //     color:'rgba(255, 255, 255, 1)',
                                                            //     marginLeft:'0.5em'
                                                            // }}
                                                            className="FilterSearch"
                                                            placeholder="Search territories"
                                                            type='text'
                                                        />
                                                        <div style={{ position: 'absolute', top: '3em', left: '0.9em', backgroundColor: 'rgba(0,0,0,90%)', width: '19.275em', borderRadius: '4px', border: '1px solid rgba(255,255,255,50%)', zIndex: '2' }}>
                                                            {territorySearch.length !== 0 &&
                                                                territorySearch.map((territory) => {
                                                                    return (
                                                                        <div className="FilterSearchItem" onClick={() => { setTerritory(territory.name); setTerritoryId(territory.id); setTerritorySearch([]); setEnableTerritorySave(true) }}>
                                                                            {territory.name} ({territory.id})
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>



                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '95%', justifyContent: 'flex-end', alignItems: 'center', paddingTop: '1em', paddingBottom: '1em' }}>
                                                        <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setTerritory(""); setTerritoryId("") }}>
                                                            Clear
                                                        </div>

                                                        {
                                                            territory.length === 0 &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setTerritory(""); setTerritoryId("") }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            territory.length !== 0 &&
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); }}>
                                                                Cancel
                                                            </div>
                                                        }

                                                        {
                                                            !enableTerritorySave &&
                                                            <div className="SaveFilterBtn" style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
                                                                Save
                                                            </div>
                                                        }
                                                        {
                                                            enableTerritorySave &&
                                                            <div className="SaveFilterBtn" onClick={() => { setFilterOption(0); setRefreshGraph(Math.random()) }}>
                                                                <div className="HoverOverlay" style={{ top: '0em' }} />
                                                                Save
                                                            </div>
                                                        }

                                                        {/* <div className="FilterBtnHeading" style={{fontSize:'0.75rem',marginLeft:'1em',cursor:'pointer'}} onClick={()=>setTerritory("")}>{t('Clear')}</div>
                                        <div className="FilterBtnHeading" style={{fontSize:'0.75rem',color:'#6D33C9',marginLeft:'1em',cursor:'pointer'}}  onClick={()=>setFilterOption(0)}>{t('Cancelbtn')}</div>
                                        <div className="FilterBtnHeading" style={{fontSize:'0.75rem',marginLeft:'1em',cursor:'pointer'}} onClick={()=>setFilterOption(0)}>{t('Savebtn')}</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div style={{ flex: 'dispay', flexDirection: 'column' }}>
                                        {
                                            filterOption === 5 && <div className="blocker" onClick={() => { setFilterOption(0); }} style={{ cursor: 'default' }}>'</div>
                                        }

                                        <div className="FilterBtn" onClick={() => setFilterOption(5)} style={{ cursor: 'pointer', position: 'relative' }}>
                                            <div className="FilterBtnHeading">{dateFilter}</div>
                                            <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon" />

                                        </div>

                                        {
                                            filterOption === 5 &&
                                            <div style={{ position: 'absolute', top: '14.5em' }}>

                                                <div className={daterange === -1 ? "DateBox" : "DateBoxOpen"} style={{ backgroundColor: '#2A333D', borderRadius: '4px', marginTop: '-0.5em', position: 'absolute', display: 'flex', flexDirection: 'column', border: '1px solid rgba(255,255,255,50%)' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                        <div style={{ marginTop: '1em', marginBottom: '1em', width: '20.875em' }}>
                                                            <div className="DateRangeH1" style={{ marginLeft: '0.88em', marginBottom: '0.88em' }}>Date Range</div>
                                                            <div className="DateObject" onClick={() => setDateRange(0)}>
                                                                <div className="DateBtnHeading"  >{t('Weeks')}</div>
                                                                <img src={PaymentInfoBtn} style={{ width: '0.5em', height: '0.875em' }} />
                                                            </div>

                                                            <div className="DateObject" onClick={() => setDateRange(1)}>
                                                                <div className="DateBtnHeading"  >{t('Monthssearch')}</div>
                                                                <img src={PaymentInfoBtn} style={{ width: '0.5em', height: '0.875em' }} />
                                                            </div>

                                                            <div className="DateObject" onClick={() => setDateRange(2)}>
                                                                <div className="DateBtnHeading"  >{t('Years')}</div>
                                                                <img src={PaymentInfoBtn} style={{ width: '0.5em', height: '0.875em' }} />
                                                            </div>

                                                            <div className="DateObject" onClick={() => setDateRange(3)}>
                                                                <div className="DateBtnHeading"  >{t('Customdaterange')}</div>
                                                                <img src={PaymentInfoBtn} style={{ width: '0.5em', height: '0.875em' }} />
                                                            </div>

                                                        </div>

                                                        {
                                                            daterange === 0 &&
                                                            <div className="DateRightContainer">
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("This Week"); setCustomStartDate(""); setCustomEndDate(""); }}>This Week</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("Last Week"); setCustomStartDate(""); setCustomEndDate(""); }}>Last Week</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("Last 7 days"); setCustomStartDate(""); setCustomEndDate(""); }}>Last 7 days</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("Last 14 days"); setCustomStartDate(""); setCustomEndDate(""); }}>Last 14 days</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("Last 30 days"); setCustomStartDate(""); setCustomEndDate(""); }}>Last 30 days</div>
                                                            </div>
                                                        }

                                                        {
                                                            daterange === 1 &&
                                                            <div className="DateRightContainer">
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(getMonthTxtFull(datetoday.getMonth()))); setCustomStartDate(""); setCustomEndDate(""); }}>{getMonthTxtFull(datetoday.getMonth())}</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(getMonthTxtFull(datetoday.getMonth() - 1))); setCustomStartDate(""); setCustomEndDate(""); }}>{getMonthTxtFull(datetoday.getMonth() - 1)}</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(getMonthTxtFull(datetoday.getMonth() - 2))); setCustomStartDate(""); setCustomEndDate(""); }}>{getMonthTxtFull(datetoday.getMonth() - 2)}</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(getMonthTxtFull(datetoday.getMonth() - 3))); setCustomStartDate(""); setCustomEndDate(""); }}>{getMonthTxtFull(datetoday.getMonth() - 3)}</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(getMonthTxtFull(datetoday.getMonth() - 4))); setCustomStartDate(""); setCustomEndDate(""); }}>{getMonthTxtFull(datetoday.getMonth() - 4)}</div>
                                                            </div>

                                                        }

                                                        {
                                                            daterange === 2 &&
                                                            <div className="DateRightContainer">
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(datetoday.getFullYear())); setCustomStartDate(""); setCustomEndDate(""); }}>This Year</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(datetoday.getFullYear() - 1)); setCustomStartDate(""); setCustomEndDate(""); }}>Last Year</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(datetoday.getFullYear() - 2)); setCustomStartDate(""); setCustomEndDate(""); }}>{datetoday.getFullYear() - 2}</div>
                                                                <div className="DateDetailsHeading" onClick={() => { setDateFilter("".concat(datetoday.getFullYear() - 3)); setCustomStartDate(""); setCustomEndDate(""); }}>{datetoday.getFullYear() - 3}</div>
                                                            </div>
                                                        }

                                                        {
                                                            daterange === 3 &&
                                                            <div className="DateRightContainer">
                                                                <div className="DateHeading" >Date From</div>
                                                                <StyledDatePickerWrapper>
                                                                    <DatePicker
                                                                        selectsStart
                                                                        selected={customstartdate}
                                                                        caretAs={calendericon}
                                                                        onChange={(date) => setCustomStartDate(date)}
                                                                        startDate={customstartdate}
                                                                        endDate={customenddate}
                                                                        maxDate={new Date()}
                                                                        dayClassName={getDayClassName}
                                                                    />
                                                                </StyledDatePickerWrapper>
                                                                <div className="DateHeading" >Date To</div>
                                                                <StyledDatePickerWrapper>
                                                                    <DatePicker
                                                                        selectsEnd
                                                                        selected={customenddate}
                                                                        onChange={(date) => setCustomEndDate(date)}
                                                                        startDate={customstartdate}
                                                                        endDate={customenddate}
                                                                        maxDate={new Date()}
                                                                        dayClassName={getDayClassName}
                                                                    />
                                                                </StyledDatePickerWrapper>
                                                            </div>
                                                        }
                                                    </div>

                                                    {
                                                        daterange !== -1 &&
                                                        <div className="DateBottom">
                                                            <div className="CancelFilterBtn" onClick={() => { setFilterOption(0); setDateRange(-1) }}>
                                                                Cancel
                                                            </div>

                                                            <div className="SaveFilterBtn" onClick={() => {
                                                                setFilterOption(0);
                                                                if (customstartdate.length !== 0 && customenddate.length !== 0) {
                                                                    setDateFilter("".concat(customstartdate.getMonth()).concat("/").concat(customstartdate.getDate()).concat("/").concat(customstartdate.getFullYear()).concat("-").concat(customenddate.getMonth()).concat("/").concat(customenddate.getDate()).concat("/").concat(customenddate.getFullYear()))
                                                                }
                                                                setRefreshGraph(Math.random())
                                                            }}>
                                                                Save
                                                            </div>
                                                        </div>
                                                    }

                                                </div>

                                            </div>
                                        }


                                    </div>

                                    <div className="ClearAllTxt" style={{ cursor: 'pointer', marginTop: '-0.5em' }} onClick={() => {
                                        setAsset("");
                                        setProduct("");
                                        setdsp("");
                                        setTerritory("");
                                        setDateFilter("Last 7 days");
                                        setCustomStartDate("");
                                        setCustomEndDate("");
                                        setRefreshGraph(Math.random());
                                    }}>
                                        {t('Clearall')}
                                    </div>
                                </div>


                            </div>
                            <div className="GraphTrendContainer">
                                <div className="GraphTrendHeader">{t('Streamsofassetandproducts')}</div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '2.5em' }}>
                                    <div className="GraphTrendAmount">{currentStatTotal.toLocaleString("en-US")}</div>
                                    {Math.round(((currentStatTotal - lastStatTotal) / lastStatTotal) * 10000) / 100 < 0 &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <img src={AnalyticsDownArrow} alt="Red Down Arrow" className="GraphTrendArrow" />
                                            <div className="GraphTrendPerc" style={{ color: '#EF3F26' }}>{Math.round(((currentStatTotal - lastStatTotal) / lastStatTotal) * 10000) / 100}%</div>
                                        </div>
                                    }

                                    {Math.round(((currentStatTotal - lastStatTotal) / lastStatTotal) * 10000) / 100 > 0 &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <img src={UpStockArrow} alt="Green Up Arrow" style={{ height: '0.5em', width: '0.6em', marginLeft: '0.5em' }} />
                                            <div className="GraphTrendPerc" style={{ color: '#94FF29' }}>{Math.round(((currentStatTotal - lastStatTotal) / lastStatTotal) * 10000) / 100}%</div>
                                        </div>
                                    }


                                </div>



                            </div>


                            <div className="GraphContainer">

                                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em', justifyContent: 'space-between', backgroundColor: 'rgba(255,255,255,8%)', paddingTop: '1.5em', paddingBottom: '1.5em', paddingRight: '1.5em', paddingLeft: '2.5em', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                                    <div className="GraphTitle">{byoption.value}</div>

                                    <div style={{ display: 'flex', flexDirection: 'row', width: '10%' }}>




                                        {
                                            graphOption === 0 &&
                                            <div className="GraphSlider">
                                                <div className="GraphSliderOption" style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px', backgroundColor: '#6D33C9', cursor: 'pointer' }}>
                                                    <img src={LineGraphIcon} style={{ height: '1.25em', width: '1.25em' }} />
                                                </div>

                                                <div className="GraphSliderOption" style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', cursor: 'pointer' }} onClick={() => setGraphOption(1)}>
                                                    <img src={BarGraphIcon} style={{ height: '1.25em', width: '1.25em' }} />
                                                </div>
                                            </div>
                                        }

                                        {
                                            graphOption === 1 &&
                                            <div className="GraphSlider">
                                                <div className="GraphSliderOption" style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px', cursor: 'pointer' }} onClick={() => setGraphOption(0)}>
                                                    <img src={LineGraphIconGrey} style={{ height: '1.25em', width: '1.25em' }} />
                                                </div>

                                                <div className="GraphSliderOption" style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', backgroundColor: '#6D33C9', cursor: 'pointer' }}>
                                                    <img src={BarGraphIconWhite} style={{ height: '1.25em', width: '1.25em' }} />
                                                </div>
                                            </div>
                                        }

                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginBottom: '2em', flexWrap: 'wrap', marginLeft: '1.5em' }}>
                                    {/* {
                            statsArray.map((dist,index)=>{
                                    return 
                                    (
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                        {/* <div style={{width:'0.6em',height:'0.6em',borderRadius:'100px',backgroundColor:colors[index%colors.length]}}/> 

                                        <div className="LegendItem">
                                        {dist.name}
                                        </div>
                                    </div>
                                    )
                                })
                            }  */}

                                    {
                                        statsArray.map((dist, index) => {
                                            // console.log(dist.name)
                                            return (
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <div style={{ width: '0.6em', height: '0.6em', borderRadius: '100px', backgroundColor: colors[index % colors.length] }} />
                                                    <div className="LegendItem">
                                                        {dist.name}
                                                    </div>
                                                </div>
                                            )

                                        })
                                    }

                                </div>



                                {
                                    graphOption === 0 &&
                                    <div>
                                        <FlexibleXYPlot height={582} xType="ordinal" style={{ paddingLeft: '5px' }} >
                                            <HorizontalGridLines style={{ stroke: '#605F76' }} tickTotal={5} />
                                            <XAxis
                                                style={{
                                                    fill: '#49454a',
                                                    fontSize: '0.625rem',
                                                    letterSpacing: '0px',
                                                    fontWeight: 'regular',
                                                    fontFamily: 'Inter',
                                                    color: '#AAA7B2'
                                                }}
                                            />
                                            <YAxis
                                                style={{
                                                    fill: '#49454a',
                                                    fontSize: '0.625rem',
                                                    letterSpacing: '0px',
                                                    fontWeight: 'regular',
                                                    fontFamily: 'Inter',
                                                    color: '#AAA7B2',
                                                    width: '5em'
                                                }}

                                                tickTotal={5}
                                            />
                                            {
                                                xgraphpoints.xycoord !== undefined && xgraphpoints.xycoord.map((stat, index) => {

                                                    return <LineMarkSeries
                                                        className="linemark-series-example"
                                                        key={index}
                                                        style={{
                                                            strokeWidth: '3px'
                                                        }}
                                                        // onSeriesMouseOver={(e)=>{
                                                        //     isHoveringOverLine.current[index] = true;
                                                        // }}
                                                        // onSeriesMouseOut={(e)=>{
                                                        //     isHoveringOverLine.current[index] = false;
                                                        // }}
                                                        // onValueMouseOver={v =>{
                                                        //                         setValue({value: v});
                                                        //                         console.log(v)}}
                                                        // onSeriesMouseOut={v =>setValue({value: false})}
                                                        // onValueMouseOver={_rememberValue} 
                                                        // onValueMouseOut={_forgetValue} 
                                                        onValueMouseOut={_forgetValue}
                                                        onValueMouseOver={_rememberValue}

                                                        color={colors[index % colors.length]}
                                                        // onNearestXY={(e, { index }) => {
                                                        //     console.log(stat[index])
                                                        //     if (isHoveringOverLine.current[index]) {
                                                        //       const hoveredLine = stat[index];
                                                        //       setHoveredPoint((prevState)=> [
                                                        //         ...prevState,
                                                        //         {
                                                        //         x: hoveredLine.x,
                                                        //         y: hoveredLine.y,
                                                        //       }]);
                                                        //     }
                                                        //   }}
                                                        // onNearestXY={(datapoint,innerX,innerY)=>{
                                                        //     console.log(datapoint)
                                                        //     // if(!myValue.includes({name:statsArray[index].name, datapoint:datapoint , position: innerX})){
                                                        //     //     setMyValue((prevstate)=>{
                                                        //     //         return [
                                                        //     //             ...prevstate,
                                                        //     //             {name:statsArray[index].name, datapoint:datapoint , position: innerX}
                                                        //     //         ]
                                                        //     //     })
                                                        //     // }
                                                        //     myValue[index]= {name:statsArray[index].name, datapoint:datapoint , position: innerX}

                                                        // }}
                                                        size={5}
                                                        data={stat}
                                                    />
                                                })
                                            }


                                            {hintValue ? (
                                                <Hint value={hintValue}>
                                                    <div
                                                        style={{
                                                            backgroundColor: '#1D2024'
                                                        }}
                                                    >
                                                        {/* x :{hintValue.y} 
                                <br/> y:{hintValue.x}  */}
                                                        <div className="LegendTitle">{hintValue.x}</div>
                                                        {
                                                            legend.length !== 0 && legend.map((val, index) => {
                                                                return (
                                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '1.5em', paddingRight: '1.01em', paddingBottom: '1.5em', width: '13em' }} onMouseLeave={_forgetValue}>
                                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                            <div style={{ width: '0.6em', height: '0.6em', borderRadius: '100px', backgroundColor: colors[index % colors.length] }} />
                                                                            <div className="LegendName">
                                                                                {val.name}
                                                                            </div>
                                                                        </div>
                                                                        <div className="LegendValue">
                                                                            {val.value}
                                                                        </div>

                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </Hint>
                                            ) : null}
                                            <Crosshair values={myValue}>
                                                <div></div>
                                            </Crosshair>
                                        </FlexibleXYPlot>
                                    </div>
                                }

                                {
                                    graphOption === 1 &&
                                    <div>
                                        <FlexibleXYPlot height={494} xType="ordinal" style={{ paddingLeft: '5px' }}>
                                            <HorizontalGridLines style={{ stroke: '#605F76' }} tickTotal={5} />
                                            <XAxis
                                                style={{
                                                    fill: '#49454a',
                                                    fontSize: '0.625rem',
                                                    letterSpacing: '0px',
                                                    fontWeight: 'regular',
                                                    fontFamily: 'Inter',
                                                    color: '#AAA7B2',
                                                    padding: '5em'
                                                }}
                                            />
                                            <YAxis
                                                style={{
                                                    fill: '#49454a',
                                                    fontSize: '0.625rem',
                                                    letterSpacing: '0px',
                                                    fontWeight: 'regular',
                                                    fontFamily: 'Inter',
                                                    color: '#AAA7B2'
                                                }}
                                                tickTotal={5}
                                            />
                                            {
                                                statsArray.length !== 0 && statsArray.map((stat, index) => {
                                                    return <VerticalBarSeries
                                                        className="linemark-series-example"
                                                        style={{
                                                            strokeWidth: '3px'
                                                        }}
                                                        // onNearestXY={(datapoint,innerX)=>{
                                                        //     console.log(statsArray[index].name)
                                                        //     console.log(datapoint)
                                                        //     console.log(innerX)
                                                        //     if(!myValue.includes({name:statsArray[index].name, datapoint:datapoint , position: innerX})){
                                                        //         setMyValue((prevstate)=>{
                                                        //             return [
                                                        //                 ...prevstate,
                                                        //                 {name:statsArray[index].name, datapoint:datapoint , position: innerX}
                                                        //             ]
                                                        //         })
                                                        //     }
                                                        //     myValue[index]= {name:statsArray[index].name, datapoint:datapoint , position: innerX}
                                                        // }}

                                                        data={xgraphpoints.xycoord[index]}
                                                    />
                                                })
                                            }
                                        </FlexibleXYPlot>
                                    </div>
                                }

                            </div>

                            <div style={{ display: 'flex', width: '90%', flexDirection: 'column', marginLeft: '2.5em', marginTop: '1.5em', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', borderRadius: '8px' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '2.5em' }}>
                                    <div className="StatsListHeader" style={{ width: '20%' }}>{t('Title')}</div>
                                    <div className="StatsListHeader" style={{ width: '20%' }}>{t('Streamsheader')}</div>
                                    <div className="StatsListHeader" style={{ width: '40%' }}>{t('Streamschange')}</div>
                                </div>
                                <div style={{ backgroundColor: '#222222', height: '1px', marginTop: '1.25em', marginBottom: '1.25em' }} />

                                {
                                    statsListArray.length !== 0 && statsListArray.sort((a, b) => b.streams - a.streams).map((obj) => {
                                        return (
                                            <div>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                    <div className="StatsListItem" style={{ width: '20%' }}>{obj.title}</div>
                                                    <div className="StatsListItem" style={{ width: '20%' }}>{obj.streams.toLocaleString("en-US")}</div>
                                                    {
                                                        obj.streamchange === 0 &&
                                                        <div style={{ width: '40%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <div className="StatsListItem" style={{ color: '#FFFFFF', marginLeft: '0.4em' }}>{obj.streamchange}</div>
                                                        </div>
                                                    }

                                                    {
                                                        obj.streamchange > 0 &&
                                                        <div style={{ width: '40%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <div className="StatsListItem" style={{ color: '#94FF29', marginLeft: '0.4em' }}>{obj.streamchange}</div>
                                                            <img src={UpStockArrow} style={{ width: '8px', height: '8px', marginLeft: '0.4em' }} />
                                                        </div>
                                                    }

                                                    {
                                                        obj.streamchange < 0 &&
                                                        <div style={{ width: '40%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <div className="StatsListItem" style={{ color: '#FF2929' }}>{obj.streamchange}</div>
                                                            <img src={DownStockArrow} style={{ width: '8px', height: '8px', marginLeft: '0.4em' }} />
                                                        </div>
                                                    }
                                                </div>
                                                <div style={{ backgroundColor: '#222222', height: '1px', marginTop: '1.25em', marginBottom: '1.25em' }} />
                                            </div>)
                                    })
                                }

                            </div>
                        </div>
                    }

                </div>
            }
        </div>


    );
}

export default Analytics;


